module.exports = __webpack_public_path__ + "img/bubble.ba3c6b13.png";